// dropdownUtils.js

export function getDropDownVal(fxid) {
    // Retrieve data from localStorage
    const storedData = localStorage.getItem("dropDowns");
    if (!storedData) return [];
  
    // Parse the stored data
    const dropdownData = JSON.parse(storedData);
  
    // Filter and return values matching the given fxid
    return dropdownData.filter(item => item.fxid === fxid);
  }
  